import { inject } from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot, UrlSegment} from "@angular/router";
import { EMPTY, Observable } from "rxjs";
import { RequestService } from "@services";
import {PagedFilter, Pages, RequestFilter, RequestStatus, RequestTypes} from "@model";
import { LIST_OF_REQUESTS } from "../app-routing.module";
import {ListOfRequestsType} from "@pages";

export const OrganizersRequestListResolver: ResolveFn<Observable<Request[]> | any> =
  (route: ActivatedRouteSnapshot,
    _: RouterStateSnapshot,
    router: Router = inject(Router),
    requestService: RequestService = inject(RequestService)): Observable<Request[]> | any => {
    const currentUrl: string = route.url.map((segment: UrlSegment) => segment.path).join('/');
    const incoming: boolean = (route.data["type"] ?? ListOfRequestsType.INCOMING) === ListOfRequestsType.INCOMING;
    if (currentUrl.includes("requests")) {
      const [filter, valid]: [RequestFilter, boolean] = getFilter(route);
      if (!valid) {
        router.navigate([LIST_OF_REQUESTS]);
        return EMPTY;
      }
      else {
        return requestService.filterRequests(new PagedFilter(new Pages(), filter), incoming);
      }
    }
    else {
      return requestService.filterRequests(new PagedFilter(new Pages(), new RequestFilter(RequestStatus.ON_HOLD)), incoming);
    }
  }

function getFilter(route: ActivatedRouteSnapshot): [RequestFilter, boolean] {
  let valid: boolean = true;
  let filter: RequestFilter = new RequestFilter();
  let selectedType: number | undefined = undefined;
  let selectedStatus: number | undefined = undefined;
  if (!!route.queryParams['status']) {
    if (!Object.values(RequestStatus).filter(v => !isNaN(Number(v))).map(v => v.toString()).includes(route.queryParams['status'])) {
      valid = false;
    }
    else {
      selectedStatus = +route.queryParams['status']
    }
  }
  if (!!route.queryParams['type']) {
    if (!Object.values(RequestTypes).filter(v => !isNaN(Number(v))).map(v => v.toString()).includes(route.queryParams['type'])) {
      valid = false;
    }
    else {
      selectedType = +route.queryParams['type']
    }
  }
  if (valid) {
    filter.status = selectedStatus;
    filter.type = selectedType;
  }
  return [filter, valid]
}
